<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-3 lbl">
            <label>Entité:</label>
          </div>
          <div class="col-9">
            <Dropdown
                class="input-width-100"
                v-model="entite"
                :options="entiteLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-3 lbl">
            <label>Du:</label>
          </div>
          <div class="col-9">
            <CustomInputDate
                class="input-width-100"
                type="date"
                max="9999-12-31"
                v-model="dateDu"
                v-on:keyup.enter="imprimer"
            />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-3 lbl">
            <label>Site d'origine:</label>
          </div>
          <div class="col-9">
            <Dropdown
                class="input-width-100"
                v-model="site"
                :options="sitesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-3 lbl">
            <label>Au:</label>
          </div>
          <div class="col-9">
            <CustomInputDate
                class="input-width-100"
                type="date"
                max="9999-12-31"
                v-model="dateAu"
                v-on:keyup.enter="imprimer"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-3 lbl">
          </div>
          <div class="col-9">
            <div class="border-white">
              <div class="row pb5 pt5 ml5">
                <div class="col">
                  <div class="row">
                    <div class="col left lbl">
                      <label class="lg">Filtrer les dossiers de repérage:</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-8"><label>Tous (Aucun filtre)</label></div>
                    <div class="col left">
                      <RadioButton id="filtre1" name="filtre" v-model="filtre" value="tous"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-8"><label>Seulement Auto vu</label></div>
                    <div class="col left">
                      <RadioButton id="filtre2" name="filtre" value="seulement_autovu" v-model="filtre"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-8"><label>Aucun Auto vu</label></div>
                    <div class="col left">
                      <RadioButton id="filtre3" name="filtre" value="aucun_autovu" v-model="filtre"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
      </div>
    </div>
  </div>
</template>



<script>
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheReperages",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  data() {
    return {
      entite: null,
      entiteLibelles: [],
      site: null,
      sitesLibelles: [],
      dateDu: null,
      dateAu: null,
      filtre: null,
      critereRecherche: {}
    };
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.fondeLibelles = entiteDecision.fonde.libelles;
      this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
        this.entite = res.data.entite;
        this.site = res.data.site;
        this.filtre = 'tous'
        this.dateDefault();
      });
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 7));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCritereRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRecherche.dateDu = new Date(this.dateDu);
      }

      this.critereRecherche.titre = this.titre;
      this.critereRecherche.entite = this.entite;
      this.critereRecherche.fonde = this.fonde;
      this.critereRecherche.genre = this.genre;
      this.critereRecherche.nature = this.nature;
      this.critereRecherche.siteOrigine = this.site;
      this.critereRecherche.type = this.type;
      return this.critereRecherche;
    },
    imprimer() {
      this.$emit("imprimer");
    },
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("narration/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: val
        })
            .then((res) => {
              this.sitesLibelles = res.data;
            });
        this.$store.dispatch('narration/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        })
            .then((res) => {
              this.genresLibelles = res.data;
            });
      } else {
        this.site = null;
        this.sitesLibelles = [];
        this.genre = null;
        this.genresLibelles = [];
      }
    },
    filtre: function (val) {
        if(val==='tous') {
            this.critereRecherche.optionAutovu = 1
        }else if(val==='seulement_autovu') {
            this.critereRecherche.optionAutovu = 2
        }else {
            this.critereRecherche.optionAutovu = 3
        }
    },
  }

}
</script>
<script setup>
</script>